import styled from 'styled-components';
import { BearInfo } from '@/components/Bear/Card/styles';
import { breakpoints } from '@/styles/breakpoints';

const StyledItems = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 2fr);
  column-gap: ${({ theme }) => theme.spacings.x2};
  row-gap: ${({ theme }) => theme.spacings.x2};

  ${breakpoints.MD} {
    column-gap: ${({ theme }) => theme.spacings.x4};
    row-gap: ${({ theme }) => theme.spacings.x4};
  }

  ${breakpoints.MDL} {
    grid-template-columns: repeat(3, 3fr);
  }

  ${breakpoints.LG} {
    grid-template-columns: repeat(3, 3fr);
  }
`;

const Item = styled.div`
  ${BearInfo} {
    padding: ${({ theme }) => theme.spacings.base};

    ${breakpoints.LG} {
      padding: ${({ theme }) => theme.spacings.x2};
    }
  }
`;

export { StyledItems, Item };
